const GLOBAL = {
  // Generic
  'current': 'currentColor',
  'transparent': 'transparent',

  // Black and White
  'black': '#000000',
  'paper': '#FFFFFF',

  // Grays
  'gray-100': '#F4F4F4',
  'gray-200': '#E5E5E5',
  'gray-300': '#C7C7C7',
  'gray-400': '#929292',
  'gray-500': '#767676',
  'gray-600': '#606060',
  'gray-700': '#323232',
  'gray-800': '#181818',

  // Cyan
  'cyan-100': '#E3F7FC',
  'cyan-200': '#C3EFF9',
  'cyan-300': '#94E2F4',
  'cyan-400': '#7EDCF2',
  'cyan-500': '#2FC6EA',
  'cyan-600': '#10839E',
  'cyan-700': '#08414F',

  // Magenta
  'magenta-100': '#FDE8F7',
  'magenta-200': '#FBD5F1',
  'magenta-300': '#F8B9E8',
  'magenta-400': '#F48CD9',
  'magenta-500': '#EB2EBA',
  'magenta-600': '#CD149D',
  'magenta-700': '#9E0F79',

  // Yellow
  'yellow-100': '#FEFDDD',
  'yellow-200': '#FDFBC9',
  'yellow-300': '#FCF3B5',
  'yellow-400': '#FFEF5F',
  'yellow-500': '#FFE602',
  'yellow-600': '#CCA700',
  'yellow-700': '#6C4904',

  // Red
  'red-100': '#FDEDED',
  'red-200': '#F8BFBF',
  'red-300': '#F18383',
  'red-400': '#EE6868',
  'red-500': '#D31717',
  'red-600': '#971111',
  'red-700': '#490808',

  // Green
  'green-100': '#E0FDCE',
  'green-200': '#BEFB98',
  'green-300': '#5CE308',
  'green-400': '#4CBB07',
  'green-500': '#3A8F05',
  'green-600': '#10601F',
  'green-700': '#0A3D14',

  // Blue
  'blue-100': '#EDEFFD',
  'blue-200': '#CCD4FA',
  'blue-300': '#8395F2',
  'blue-400': '#425EEB',
  'blue-500': '#1634CC',
  'blue-600': '#102798',
  'blue-700': '#091553',

  // Orange
  'orange-100': '#FFD7BD',
  'orange-200': '#FFAC75',
  'orange-300': '#FF8838',
  'orange-400': '#FA6400',
  'orange-500': '#C75000',
  'orange-600': '#A84300',
  'orange-700': '#6B2B00',

  // Purple
  'purple-100': '#EAD1FA',
  'purple-200': '#D8A8F6',
  'purple-300': '#BB67EF',
  'purple-400': '#AB42EB',
  'purple-500': '#9819E6',
  'purple-600': '#7413AF',
  'purple-700': '#4F0D78',
};

const ALIAS = {
  'offwhite': GLOBAL['gray-100'],
  'newsletter-blue': GLOBAL['blue-500'],
};

export const COLORS = {
  GLOBAL,
  ALIAS,
};
